(() => {
  const root = document.querySelector('.ulike-led-live');
  if (!root) return;
  const report = message => {
    let notice = root.querySelector('[data-led-cart-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.ledCartStatus = '';
      notice.setAttribute('role', 'alert');
      root.prepend(notice);
    }
    notice.textContent = message;
  };
  window.ulikeLedAddToCart = async (id, code) => {
    if (!/^\d+$/.test(String(id))) throw new Error('Missing product variant');
    const base = window.Shopify?.routes?.root || '/';
    try {
      if (code) {
        const discount = await fetch(`${base}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(base + 'cart')}`);
        if (!discount.ok) throw new Error('Unable to apply the offer. Please try again.');
      }
      const response = await fetch(`${base}cart/add.js`, {
        method: 'POST', headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({items:[{id:String(id),quantity:1}],sections:['mini-cart']})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true,detail:{openMiniCart:true}}));
      report('Added to cart.');
      return data;
    } catch (error) { report(error.message); throw error; }
  };
})();
